import NewSlideshow from '../../classes/NewSlideshow';

export const initSlider = () => {
	const sliders = document.querySelectorAll( 'section.slider' );

	if ( !sliders.length )
	{
		return;
	}

	Array.from( sliders ).forEach( ( it ) => {
		const sliderInstance = new NewSlideshow( {
			element: it,
			loop: true,
			shrink: 0.6,
			autoPlay: true,
			autoPlayTime: 5500,
			withVideo: true,
			beforeSwitchCallback: () => {
				const playingVideos = it.querySelectorAll( 'figure.playing' );

				if ( !playingVideos.length )
				{
					return;
				}
				
				Array.from( playingVideos ).forEach( ( figure ) => {
					const video = figure.querySelector( 'video' );

					figure.classList.remove( 'playing' );
					video.pause();
				} );
			},
			switchCallback: ( slide ) => {
				const figure = slide.querySelector( 'figure' );
				const video = figure.querySelector( 'video' );

				if ( !video )
				{
					return;
				}

				figure.classList.add( 'playing' );
				video.play();
			}
		} );

		sliderInstance.init();

		const slider = it.querySelector( 'ul.slides' );

		const fixHeight = (  ) => {
			slider.style.height = '';
			
			setTimeout( () => {
				slider.style.height = `${slider.offsetHeight}px`;
			}, 2000 );
		};

		fixHeight();
		window.addEventListener( 'resize', fixHeight );

		Array.from( it.querySelectorAll( 'figure.video button.play' ) ).forEach( ( button ) => {
			button.addEventListener( 'click', ( evt ) => {
				const figure = evt.target.closest( 'figure' );
				const video = figure.querySelector( 'video' );

				if ( figure.classList.contains( 'playing' ) )
				{
					figure.classList.remove( 'playing' );
					video.pause();
				}
				else
				{
					figure.classList.add( 'playing' );
					video.play();
				}
			} );
		} );

		Array.from( it.querySelectorAll( 'figure.video button.mute' ) ).forEach( ( button ) => {
			const svgPath = button.querySelectorAll( 'svg path' );
			svgPath[0].style.display = 'none';

			button.addEventListener( 'click', ( evt ) => {
				const figure = evt.target.closest( 'figure' );
				const video = figure.querySelector( 'video' );

				if ( video.muted === true )
				{
					video.muted = false;
					svgPath[0].style.display = 'block';
					svgPath[1].style.display = 'none';

				} else {
					video.muted = true;
					svgPath[0].style.display = 'none';
					svgPath[1].style.display = 'block';
				}
			} );
		} );
	} );
};
